import template from './video-chat.loading-screen.html';
import { EndCallReasons } from 'common/services/doxy-analytics/tracks/video-session-end';

export default angular
  .module('doxy.videoChat.loadingScreen', [])
  .component('videoChatLoadingScreen', {
    //video-chat-loading-screen
    template,
    bindings: {
      isLoading: '<',
      hasVideo: '<',
    },
    controller: function (
      $timeout,
      $translate,
      notificationFactory,
      communicationControl,
      $log,
      $rootScope
    ) {
      const debug = $log.debug.bind($log, 'videoChatLoadingScreen:');
      this.isLoaderVisible = false;

      let cancelCallPromise;
      let finalizeTextPromise;

      $rootScope.$on(
        'video-chat-loading-screen:update-message',
        (e, message) => {
          this.customMessage = $translate.instant(message);
          resetMessage();
        }
      );

      const resetMessage = () => {
        if (this.customMessage) {
          this.message = $translate.instant(this.customMessage);
          return;
        }
        if (this.hasVideo)
          this.message = $translate.instant('session.video-call-initialize');
        else this.message = $translate.instant('session.audio-call-initialize');
      };

      this.$onInit = () => {
        resetMessage();
      };

      this.setIsLoaderVisible = (value) => {
        this.isLoaderVisible = value;
        debug('isLoaderVisible', this.isLoaderVisible);
      };

      this.$onChanges = (changes) => {
        const visibilityChange = changes.isLoading;
        if (!visibilityChange) return;

        debug('changes.isLoading', changes.isLoading, this.resetTimeout);

        if (
          visibilityChange.currentValue === true &&
          visibilityChange.previousValue === false
        ) {
          if (this.resetTimeout) {
            $timeout.cancel(this.resetTimeout);
            debug('resetTimeout');
            this.resetTimeout = null;
          }

          if (this.isLoaderVisible) return;

          this.setIsLoaderVisible(true);

          resetMessage();

          cancelCallPromise = $timeout(() => {
            resetMessage();

            this.setIsLoaderVisible(false);
            $rootScope.$emit(
              'activeProvider:endReason',
              EndCallReasons.TIMEOUT
            );
            communicationControl.phoneStop();
            notificationFactory.showCommon('info', 'video-timeout');
          }, 1000 * 30);

          finalizeTextPromise = $timeout(() => {
            this.message = $translate.instant('session.finalize-connection');
          }, 4900);
        }

        if (
          visibilityChange.currentValue === false &&
          visibilityChange.previousValue === true
        ) {
          this.customMessage = null;
          this.resetTimeout = $timeout(() => {
            resetMessage();
            this.setIsLoaderVisible(false);
          }, 600);
          $timeout.cancel(cancelCallPromise);
          $timeout.cancel(finalizeTextPromise);
        }
      };
    },
  }).name;
